var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"card",attrs:{"role":"main"}},[_c('h1',[_vm._v("ExampleComponent")]),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }